import React from 'react';

import { availableCreditAmount } from '../../../../lib/utils/credit_line';
import { formatWholeDollars } from '../../../../lib/utils/formatters';

export default function CreditLineSummary({ company }) {
  const amount = availableCreditAmount(company);
  if (amount === null || amount < 1) return null;

  return (
    <div
      data-testid="credit-line-summary"
      className="rounded-lg border border-primary-border-gray bg-[#f9f9f9] p-3 sm:p-4 my-4 flex items-center justify-between gap-2"
    >
      <span className="sm:text-lg">Credit available to use now:</span>
      <span className="text-lg sm:text-xl font-bold">
        {formatWholeDollars(amount)}
      </span>
    </div>
  );
}
